import { CanvasPcodeVideoFrameParams } from '../../../service/Pcode/PcodeCanvasVideo';
import { LocalStorage, StorageKeyType } from '../../../service/Storage/Storage';
import { PcodeAds } from '../../../typings/pcode';
import { CreativeType, SharedData } from '../../common/typings';
import {
    CommonOptionGroupName,
    CreativeOptionData,
    CreativeOptionGroupConfig,
    CreativeOptionsConfig,
    CreativeOptionsGroupValue,
    CreativeOptionsValue,
    CreativeOptionType,
    VideoOptionName
} from '../../CreativeOptions/typings';
import { AddCreativeState, AddOverlayCreativeState, AddVideoCreativeState } from '../typings';

export const getVideoPcodePreviewData = (vast: string): Partial<CanvasPcodeVideoFrameParams> => {
    return {
        vast,
        autostartoff: true,
        soundOnStart: LocalStorage.getItem(StorageKeyType.isVideoCreativesSoundEnabled) as boolean
    };
};

export const getVideoCreativeOptionsValue = (
    values: CreativeOptionsValue,
    config: CreativeOptionsConfig,
    videoPreviewData?: PcodeAds,
    isAudio?: boolean
): CreativeOptionsValue => {
    const optionValues = values.slice();

    // Для пресетов в cpm audio с бекенда приходит значение video_id
    // из-за этого значения потом приходит ошибка с бекенда о том, что video_id не может быть задано для cpm_audio
    if (isAudio) {
        optionValues.forEach((value: CreativeOptionsGroupValue) => {
            if (Object.keys(value.options).includes(VideoOptionName.video)) {
                delete value.options[VideoOptionName.video];
            }
        });
    }

    if (!videoPreviewData) {
        return optionValues;
    }

    // Подставляем в параметры типа text и age значения из данных превью
    Object.keys(videoPreviewData).forEach((previewOptionName: string) => {
        const group = optionValues.find(elem => elem.type === previewOptionName);
        const groupConfig: CreativeOptionGroupConfig = config[previewOptionName];

        if (!group || videoPreviewData[previewOptionName] === '' || !groupConfig) {
            return;
        }

        switch (group.type) {
            case CommonOptionGroupName.logo:
            case CommonOptionGroupName.image:
                return;

            default:
                break;
        }

        const optionType =
            previewOptionName === CreativeOptionType.Age ? CreativeOptionType.Age : CreativeOptionType.Text;

        const optionConfig = groupConfig.options.find(elem => elem.type === optionType);

        if (!optionConfig) {
            return;
        }

        group.options[optionType] = videoPreviewData[previewOptionName];

        // если параметр можно редактировать, то не нужно добавлять в массив для удаления при отправке на бек
        if (optionConfig.editable) {
            return;
        }

        if (group.optionsFromPreviewData) {
            group.optionsFromPreviewData.push(optionType);
        } else {
            group.optionsFromPreviewData = [optionType];
        }
    });

    return optionValues;
};

export function getOptionsDependingOnVideoColor(config: CreativeOptionsConfig): { groupName: string; name: string }[] {
    return Object.keys(config).reduce((acc: { groupName: string; name: string }[], groupName: string) => {
        const groupConfig = config[groupName];

        groupConfig.options.forEach((option: CreativeOptionData) => {
            if (option.type === CreativeOptionType.ColorPicker && option.dependsOnVideoColor) {
                acc.push({ name: option.name, groupName });
            }
        });

        return acc;
    }, []);
}

export const getVideoCreativeState = (state: AddCreativeState): AddVideoCreativeState | undefined => {
    switch (state.type) {
        case CreativeType.VIDEO_ADDITION:
            return state;

        default:
            throw undefined;
    }
};

export function getIsCpmAudio(sharedData: SharedData): boolean {
    return Boolean(sharedData.cpm_audio);
}

export function getIsVideoAddition(sharedData: SharedData): boolean {
    return Boolean(sharedData.cpm || sharedData.cpc);
}

export const getVideoOrOverlayCreativeState = (
    state: AddCreativeState
): AddVideoCreativeState | AddOverlayCreativeState | undefined => {
    switch (state.type) {
        case CreativeType.VIDEO_ADDITION:
        case CreativeType.OVERLAY:
            return state;

        default:
            throw undefined;
    }
};
